export const getShopifyStringId = (completeId: string): string | undefined => {
  return completeId.split('/').pop();
};
